import { gql } from '@apollo/client';
import { getCookie } from '../hooks/useCookie';

const QUERIES = {
  EXTEND_SESSION: gql`
    query refreshToken($refresh_token: String!) {
      refreshToken(refresh_token: $refresh_token) {
        access_token
        expires_in
        refresh_expires_in
        refresh_token
      }
    }
  `,
};

// eslint-disable-next-line
export const extendSessionApi = async graphql => {
  const token = getCookie('refresh_Token');
  const { data } = await graphql.query({
    query: QUERIES.EXTEND_SESSION,
    variables: { refresh_token: token },
  });

  return data;
};
